module.exports = __webpack_public_path__ + "static/media/mimic-chest.dc67da5d.svg";